import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";

const Footer = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  const footerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut", staggerChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
  };

  const presenceLinks = [
    {
      name: "Ethiccraft_Handbook",
      href: "https://www.youtube.com",
    } /* Use Https:// before every link */,
  ];

  return (
    <footer className="footer" ref={ref}>
      <motion.div
        className="footer-container"
        variants={footerVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
      >
        <motion.div className="footer-column" variants={itemVariants}>
          <h3 className="footer-title">Ethiccraft Club</h3>
          <p className="contact-info">
            <FaMapMarkerAlt />
            House No. 28, Block UA, Jawahar Nagar, Opposite Hansraj Boys Hostel,
            New Delhi 110007
          </p>
          <p className="contact-info">
            <FaPhoneAlt /> +91 88608 30455
          </p>
          <p className="contact-info">
            <FaEnvelope /> info@ethiccraft.org
          </p>
          <div className="social-icons">
            <a
              href="https://www.instagram.com/ethiccraft_org"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://youtube.com/@EthiccraftClubOfficial"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>
            <a
              href="https://whatsapp.com/channel/0029VbB2VTTGk1FsJT7ydJ10"
              aria-label="Whatsapp"
            >
              <FaWhatsapp />
            </a>
          </div>
          <div className="channnel-qr-section">
            <img
              src="/assets/Instagram_Channel_QR.jpg"
              alt="WhatsApp Channel QR Code"
              className="qr"
            />
            <img
              src="/assets/WhatsApp_Channel_QR.jpg"
              alt="WhatsApp Channel QR Code"
              className="qr"
            />
          </div>
        </motion.div>

        <motion.div className="footer-column" variants={itemVariants}>
          <div className="Channel-links-section">
            <h3 className="footer-title">Downloads</h3>
          </div>
          {/* <h3 className="footer-title">Downloads</h3> */}
          <ul className="footer-links two-column-list">
            {presenceLinks
              .reduce((rows, item, index) => {
                if (index % 2 === 0) {
                  rows.push([item, presenceLinks[index + 1]]);
                }
                return rows;
              }, [])
              .map((pair, rowIndex) => (
                <li key={rowIndex} className="link-pair-row">
                  {pair.map((link, colIndex) => {
                    if (!link) return null;
                    const finalHref = link.href.startsWith("http")
                      ? link.href
                      : `/${link.href}`;

                    return (
                      <a
                        key={colIndex}
                        href={finalHref}
                        className="link-pair"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {link.name}
                      </a>
                    );
                  })}
                </li>
              ))}
          </ul>
        </motion.div>
      </motion.div>
      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Ethiccraft Club. All Rights
          Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
